import React from 'react';

export default React.createContext({
  back: false,
  basePath: '',
  region: 'eu',
  currentStep: 0,
  maxStep: 0,
});
